import React from "react";
import { formatCurrency } from '../utils/currencyFormatter';

const Summary = ({ totalExpenses }) => {
  const currentMonth = new Date().toLocaleString('default', { month: 'long' });
  
  return (
    <div
      className="text-center text-white mb-4 custom-emerald position-relative overflow-hidden"
      style={{
        padding: "30px 0",
        height: "250px",
      }}
    >
      {/* Decorative Background Elements */}
      <div className="decoration-container">
        {/* Wave Pattern */}
        <svg className="waves" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path 
            d="M0,50 C30,60 70,40 100,50 L100,100 L0,100 Z" 
            fill="rgba(255,255,255,0.1)"
          />
          <path 
            d="M0,60 C40,70 60,50 100,60 L100,100 L0,100 Z" 
            fill="rgba(255,255,255,0.08)"
          />
        </svg>

        {/* Animated Graph Lines */}
        <svg className="graph-lines" viewBox="0 0 100 100" preserveAspectRatio="none">
          <polyline 
            points="0,80 20,70 40,75 60,50 80,60 100,40"
            className="graph-line"
          />
          <polyline 
            points="0,85 20,75 40,80 60,55 80,65 100,45"
            className="graph-line graph-line-2"
          />
        </svg>

        {/* Circular Patterns */}
        <div className="circles">
          {[...Array(5)].map((_, i) => (
            <div key={i} className={`circle circle-${i + 1}`} />
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="content-wrapper position-relative">
        <p className="mb-2">{currentMonth}'s spend</p>
        <h1 className="display-5 fw-bold">{formatCurrency(totalExpenses)}</h1>
      </div>
    </div>
  );
};

export default Summary;